/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_Client,
  EnumerableCommandResult_Client,
  ListCommandResult_Client
} from "@graphql/helpers/types.graphql";
import { CommandResult, EnumerableCommandResult, ListCommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TClientType,
  TConstructionType,
  TJoin,
  TNonEmptyArray,
  TPermissionUserType,
  TUserType
} from "@graphql/helpers/utils.graphql";

type TClientByIdFunctions = {
  getByID: CommandResult_Client;
};
export type TClientByIdQueries = {
  client: TClientByIdFunctions;
};

type TGlobal =
  | TClientType
  | TJoin<"constructions", TConstructionType>
  | TJoin<"constructions.permissionsUsers", TPermissionUserType>
  | TJoin<"constructions.permissionsUsers.user", TUserType>;

export const clientById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query clientById($id: Guid!) {
    client {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Client")}
`;

type TClientAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_Client;
};
export type TClientAllWithPaginationQueries = {
  client: TClientAllWithPaginationFunctions;
};
export const clientAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query clientAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    client {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Client")}
`;

type TClientAllWithoutPaginationFunctions = {
  getAllWithoutPagination: EnumerableCommandResult_Client;
};
export type TClientAllWithoutPaginationQueries = {
  client: TClientAllWithoutPaginationFunctions;
};
export const clientAllWithoutPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query clientAllWithoutPagination($where: [WhereClausesInputType]) {
    client {
      getAllWithoutPagination(where: $where) {
        ...ENUMERABLE_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${EnumerableCommandResult("EnumerableCommandResult_Client")}
`;

type TClientAllWithSortedPaginationFunctions = {
  getAllWithSortedPagination: ListCommandResult_Client;
};
export type TClientAllWithSortedPaginationQueries = {
  client: TClientAllWithSortedPaginationFunctions;
};
export const clientAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query clientAllWithSortedPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]) {
    client {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Client")}
`;
